import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [loading, setLoading] = useState(true);
  const [me, setMe] = useState({ loggedIn: false });

  async function refreshMe() {
    try {
      const res = await fetch("/api/auth/me", { credentials: "include" });
      const data = await res.json();
      setMe(data?.loggedIn ? data : { loggedIn: false });
    } catch {
      setMe({ loggedIn: false });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    refreshMe();
  }, []);

  const value = useMemo(
    () => ({
      loading,
      me,
      refreshMe,
      login: (returnTo = "/") => {
        // backend-owned redirect
        window.location.assign(`/api/auth/login?returnTo=${encodeURIComponent(returnTo)}`);
      },
      logout: async () => {
        await fetch("/api/auth/logout", {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
        });
        await refreshMe();
      },
    }),
    [loading, me]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
